import { apiCall, NEW_BE_API } from '../../utils/APIFunctions';

export function fetchOfflineData() {
  return apiCall(`${NEW_BE_API}/api/n1/offline`, "GET");
}

export function checkOnlineStatus() {
  return apiCall(`${NEW_BE_API}/api/n1/offline/check-online`, "GET");
}